import {
  buildTeammateDisplayNames,
  type BasicTeammate,
} from "@repo/app-types/entities/teammate";
import type { ReactNode } from "react";

export function renderTeammateName(
  teammate: BasicTeammate | undefined,
): ReactNode {
  return teammate
    ? buildTeammateDisplayNames(teammate).primaryDisplayName
    : null;
}
